import { compactViewMixinPage } from '../../mixins/compactViewMixinPage/compactViewMixinPage';

const NS = 'LoginPage';
const CLS = 'loginPage';

export class LoginPage {
	constructor(element) {
		this.element = element;
		this.$element = $(this.element);
		this.$tplScroller = $('.tpl-scroller');

		this.$element.on('click', '[data-step-toggler]', (event) => {
			let stepTargetValue = $(event.currentTarget).data('stepTarget');
			this.goToStep(stepTargetValue);
		});

		this.goToStep('login');

		this.initCompactView(this);
		this.$element.css({
			visibility: 'visible'
		});
	}

	goToStep(stepTargetValue) {
		this.$element.find('[data-step]').not(`[data-step='${stepTargetValue}']`).fadeOut(0).removeClass('is-active');
		let $stepTarget = this.$element.find(`[data-step='${stepTargetValue}']`);

		$stepTarget.fadeIn(0).addClass('is-active');
		scrollTo(this.$tplScroller[0], { top: 0, duration: 0 }); // Just scroll to the top of the page without animation
	}
}

Object.assign(LoginPage.prototype, compactViewMixinPage);
